<script setup lang="ts">
/**
 * Root-Component. Inhalt kommt vom Router (Public-Layout, Login, Dashboard, etc.).
 * CookieBanner haengt unten als Overlay und schiebt sich beim ersten Besuch ein.
 */
import CookieBanner from '@/components/CookieBanner.vue';
import { useAuthStore } from '@/stores/auth';
import { onMounted } from 'vue';

const auth = useAuthStore();

// Beim Start einmal kurz checken, ob das Session-Cookie noch gueltig ist.
// Falls ja, kriegen wir den Spieler-Datensatz und der Router kann
// authentifizierte Routen freischalten. Failures sind okay — nicht-eingeloggt.
onMounted(() => auth.restore());
</script>

<template>
  <router-view />
  <CookieBanner />
</template>
